import { render, staticRenderFns } from "./RewardName.vue?vue&type=template&id=2012e809&"
import script from "./RewardName.vue?vue&type=script&lang=js&"
export * from "./RewardName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports